<template>
  <div class="form-group row">
    <label
      class="col-form-label"
      :class="nolabel ? '' : 'col-sm-' + labelCol"
      v-if="nolabel !== true"
    >{{ title || "&nbsp;" }}</label>

    <div :class="nolabel ? 'col-sm-12' : 'col-sm-' + (12 - labelCol)">
      <div class="input-group">
         <input :disabled="readonly?true:false" :id="id" type="text" ref="input" class="form-control datepicker" autocomplete="off" />
        <div class="input-group-prepend">
          <div class="input-group-text">
            <i class="far fa-calendar"></i>
          </div>
        </div>
        
      </div>
    </div>

   
  </div>
</template>

<script>
export default {
  props: [
    "id",
    "title",
    "placeholder",
    "labelwidth",
    "value",
    "required",
    "readonly",
    "minDate",
    "maxDate",
    "nolabel"
  ],
  computed: {
    tracker() {
      return this.$store.getters.getChangeTracker;
    },
    labelCol() {
      return this.labelwidth || 3;
    }
  },

  data() {
    return {
      // date: "",
      inited: false,
      isValid: true,
      val: null
    };
  },

  watch: {
    date: function(val) {
      // console.log($('#'+this.id).data('daterangepicker'));
      // this.$emit("input", val);
      // console.log(this.input)
    },
    value: function(val) {
      if (val) {
        // console.log(val);
        $(this.$refs.input).val(val);
        this.initDatepicker();
        this.$emit("input", val);
        // $(this.$refs.input)
        //   .data("daterangepicker")
        //   .setStartDate(val);
      } else {
        $(this.$refs.input).val("");
        this.$emit("input", "");
      }
    }
  },
  mounted() {
    let $vm = this;
    if (this.value) {
      $(this.$refs.input).val(this.value);
    }
    this.$nextTick(() => {
      $(this.$refs.input).focus(() => {
        this.$emit("clickEvent", "");
      });

      $(this.$refs.input).on("input", () => {
        this.$emit("input", $(this.$refs.input).val());
      });

      this.initDatepicker();
    });
  },
  methods: {
    initDatepicker() {
      let $vm = this;
      if (jQuery().daterangepicker) {
        if ($(this.$refs.input).length) {
          $(this.$refs.input)
            .daterangepicker({
              locale: {
                format: "YYYY-MM-DD"
              },
              autoApply: true,
              singleDatePicker: true,
              autoUpdateInput: false,
              minDate: "2000-01-01",
              showDropdowns: true,
              maxDate: `${parseInt(moment().format("YYYY"), 10)}-12-31`
            })
            .on("apply.daterangepicker", function(e, picker) {
              let date = picker.startDate.format(picker.locale.format);
              $(this.$refs.input).val(date);
              $vm.$emit("input", date);
            })
            .on("hide.daterangepicker", function(e, picker) {});
        }
      }
    }
  }
};
</script>